import useContextMenu from '@/components/ContextMenu/Base/hooks/useContextMenu';
import React, {
  ComponentProps,
  MouseEvent as ReactMouseEvent,
  TouchEvent as ReactTouchEvent,
  useCallback, useRef, useState
} from 'react';
import ChatContextMenu from '@/components/Chat/ChatContextMenu/ChatContextMenu';
import { Chat } from '@/store/chats/chats';
import useChatActions from '@/hooks/useChatActions';
import ContextMenuList from '@/components/ContextMenu/ContextMenuList/ContextMenuList';

interface IUseChatContextMenu {
  props: ComponentProps<typeof ChatContextMenu>
  show: (e: ReactMouseEvent | ReactTouchEvent, chat: Chat) => void
  hide: () => void
}

type OnClickContextMenu = (action: string, message: any, e: React.MouseEvent<HTMLLIElement, MouseEvent>) => void

interface ChatContextMenuProps {
  onClickContextMenu?: OnClickContextMenu
  onHide?: () => void
}

const useChatContextMenu = (
  {
    onClickContextMenu,
    onHide
  }: ChatContextMenuProps): IUseChatContextMenu => {
  const [chat, setChat] = useState<Chat>()
  const [listProps, setListProps] = useState<ComponentProps<typeof ContextMenuList>>({
    list: []
  })
  const onClickContextMenuRef = useRef<OnClickContextMenu | undefined>(onClickContextMenu);
  onClickContextMenuRef.current = onClickContextMenu

  const {
    show: showContextMenu,
    visible: visibleContextMenu,
    hide: hideContextMenu,
    contextMenuProps
  } = useContextMenu({
    onHide
  })

  const { getList } = useChatActions()

  const contextMenuHandler = useCallback((...props: Parameters<OnClickContextMenu>) => {
    onClickContextMenuRef.current?.(...props)
  }, [])

  const show = useCallback((e: ReactMouseEvent | ReactTouchEvent, chat: Chat) => {
    setChat(chat)
    setListProps({
      list: getList(chat),
      message: chat,
      onClick: contextMenuHandler,
    })
    showContextMenu(e)
  }, [contextMenuHandler, getList, showContextMenu])

  return {
    show,
    hide: hideContextMenu,
    props: {
      visibleContextMenu,
      chat,
      listProps,
      contextMenuProps
    }
  }
}

export default useChatContextMenu
